import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';
import { SezioneBeniMobili } from '../../../models/sezioni/sezione-beni-mobili';
import { BeniMobiliUpdateComponent } from './beni-mobili-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [beni-mobili-mod-update]',
  templateUrl: 'beni-mobili-mod-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class BeniMobiliModUpdate {
  @ViewChild('formBeniMobiliUpdate') formBeniMobili: BeniMobiliUpdateComponent;

  @Output()
  onReturn: EventEmitter<SezioneBeniMobili> = new EventEmitter<SezioneBeniMobili>();


  inizializza(beneMobile: BeneMobile, urlUpdateBene: string, idSezione: string) {
    this.formBeniMobili.inizializza(beneMobile, urlUpdateBene, idSezione );
    openModal('modalupdateBeniMobili');
  }

  createForm() {
    this.formBeniMobili.createForm();
  }

  manageModal(sezione: SezioneBeniMobili) {
    closeModal('modalupdateBeniMobili');
    this.onReturn.emit(sezione);
  }
}
